export const ECESS_TOKEN = 'ECESS_TOKEN';
export const CASHBOOK_USER = 'CASHBOOK_USER';
export const ACCOUNT_SELECTED = 'ACCOUNT_SELECTED'
export const BOOK_SELECTED = 'BOOK_SELECTED'



export const setCashbookUser = (data) => {
  localStorage.setItem(CASHBOOK_USER, JSON.stringify(data));
};

export const getAcessToken = () => {
  return localStorage.getItem(ECESS_TOKEN);
};

export const setAcessToken = (data) => {
  localStorage.setItem(ECESS_TOKEN, data);
};

export const getCahbookUser = () => {
  const data = localStorage.getItem(CASHBOOK_USER);
  return data && data !== 'undefined' ? JSON.parse(data) : null;
};
export const setSelectedAccount = (data) => {
  localStorage.setItem(ACCOUNT_SELECTED, JSON.stringify(data));
};

export const getSelectedAccount = () => {
  const data = localStorage.getItem(ACCOUNT_SELECTED);
  return data && data !== 'undefined' ? JSON.parse(data) : null;
};

export const setSelectedBook = (data) => {
  localStorage.setItem(BOOK_SELECTED, JSON.stringify(data));
};

export const getSelectedBook = () => {
  const data = localStorage.getItem(BOOK_SELECTED);
  return data && data !== 'undefined' ? JSON.parse(data) : null;
};


export const removeCashbookUser = () => {
  if (localStorage.getItem(CASHBOOK_USER)) {
    localStorage.removeItem(CASHBOOK_USER);
    return true;
  }
  return false;
};


export const removeAcessToken = () => {
  if (localStorage.getItem(ECESS_TOKEN)) {
    localStorage.removeItem(ECESS_TOKEN);
    return true;
  }
  return false;
};
